var React = require('react');

function Union (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96 48v236.21c0 46.43 31.29 89.08 76.87 97.93A96.16 96.16 0 0 0 288 288V48a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v233.32c0 97.57-70 184.64-166.74 197.06C100.17 493.4 0 402.18 0 288V48a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16z","className":"fa-secondary","key":1})]);
}

Union.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Union;

Union.default = Union;
